export const CLASS_NAMES = {
	page: 'min-h-screen bg-[#F2F5F9] text-[var(--color-primary-900)] [font-family:Overpass,Inter,sans-serif]',
	layoutBody: 'flex flex-1 min-h-0 justify-center'
} as const;
